import CopyPresenter from '../app-core/modals/copy-presenter'

import SchemeServicingManager from '@/scheme-servicing-manager'

export default {

    props: {
        isDirect: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            /**
             * @type {Array<{name: string, schemes: Array<string>}>}
             */
            umbrellaPartners: [],

            loaded: false,
        }
    },

    computed: {

        /**
         * @returns {SchemePolicy}
         */
        data() {
            return this.$scheme.policyData
        },

        /**
         * @returns {boolean}
         */
        isUmbrella() {
            return this.$scheme.isUmbrella
        },

        /**
         * @returns {boolean}
         */
        showRetrofitWorksAsWell() {
            return !this.data.licensee.isSubsidiary && this.data.operator.isRetrofitWorks && this.data.licensee.name !== 'RetrofitWorks Ltd'
        },
    },

    methods: {
        /**
         * Gets all of the partners linked to national schemes.
         * @returns {Promise<Array<{name: string, schemes: Array<string>}>>}
         */
        async getUmbrellaPartners() {
            const partners = await SchemeServicingManager.getPartnersForUmbrellaSchemeAsync()
            return partners.map(p => {
                return {
                    name: p.name,
                    schemes: p.linkedSchemes
                        .filter(() => p.name !== 'RetrofitWorks Ltd')
                        .map(ls => ls.title)
                        .join(', '),
                }
            })
        },

        /**
         * Shows a modal policy.
         * @param {Vue|{directRouteName: string}} nestedComponent
         * @param {string} title
         * @param {Object} modalEvents
         */
        showPolicy(nestedComponent, title, modalEvents = {}) {
            if (this.isDirect) {
                this.$router.push({ name: nestedComponent.directRouteName })
            } else {
                const modalData = {
                    data: { title },
                    cssModifier: 'policy',
                    nestedComponent,
                }
                Object.assign(modalData, modalEvents)
                this.$eventbus.$emit(this.$appevents.showModal, CopyPresenter, modalData)
            }
        },
    },
}
